import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, Box, Chip, Button, Divider } from "@mui/material";

const ViewSceneDetails = ({ open, onClose, data, title, theme }) => {
  if (!data) {
    return (
      <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
        <DialogTitle sx={{ backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary }}>
          {data?.name || "Details"}
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: theme.palette.background.background, color: theme.palette.text.primary }}>
          <Typography variant="body1">No data available</Typography>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: theme.palette.background.paper }}>
          <Button onClick={onClose} color="info">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle sx={{ backgroundColor: theme.palette.background.paper, color: theme.palette.text.primary }}>
        {data?.name || "Scene Details"}
      </DialogTitle>
      <DialogContent sx={{ backgroundColor: theme.palette.background.default, color: theme.palette.text.primary }}>
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {/* Scene Name */}
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Scene Name:
            </Typography>
            <Typography variant="body1">{data.name || "N/A"}</Typography>
          </Box>
         

          {/* Captions */}
          <Box>
            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
              Captions:
            </Typography>
            {data.captions && data.captions.length > 0 ? (
              data.captions.map((caption, index) => (
                <Box
                  key={index}
                  sx={{
                    border: "1px solid",
                    borderColor: theme.palette.divider,
                    borderRadius: 2,
                    p: 2,
                    mb: 2,
                    backgroundColor: theme.palette.background.paper,
                  }}
                >
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    {caption.caption_name || `Caption ${index + 1}`}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {caption.description || "No description available"}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 1 }}>
                    <Chip
                      label={`Version: ${caption.version || "v1.0"}`}
                      size="small"
                      color="primary"
                    />
                    {caption.fileName && (
                      <Chip
                        label={caption.fileName}
                        size="small"
                        variant="outlined"
                      />
                    )}
                  </Box>
                  {/* All Versions */}
                  {caption.all_versions && caption.all_versions.length > 0 && (
                    <Box sx={{ mt: 2 }}>
                      <Typography variant="body2" sx={{ fontWeight: "bold", mb: 1 }}>
                        All Versions:
                      </Typography>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                        {caption.all_versions.map((version, versionIndex) => (
                          <Chip
                            key={versionIndex}
                            label={version}
                            size="small"
                            sx={{
                              backgroundColor: theme.palette.primary.light,
                              color: theme.palette.text.primary,
                            }}
                          />
                        ))}
                      </Box>
                    </Box>
                  )}
                </Box>
              ))
            ) : (
              <Typography variant="body2">No captions available</Typography>
            )}
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ backgroundColor: theme.palette.background.paper }}>
        <Button onClick={onClose} sx={{ color: theme.palette.primary.main }}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewSceneDetails;